import React from 'react';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import WorkTicketsList from 'src/component/UI/WorkTicketsList';
import { getWorkTickets, getLoadingWorkTickets, getNumWorkTicketPages, getTotalWorkTickets } from 'src/module/workTicket/selector';
import { fetchWorkTickets } from 'src/module/workTicket/action';
import { getPluralWorkTicketLabel } from 'src/module/authentication/selector';
import FilterBar from 'src/component/UI/FilterBar';
import { isWhitelabel } from 'src/utils/utils';
import { useTranslation } from 'src/i18n';


export default function WorkTicketScreen () {
  const { t } = useTranslation();
  const selectors = {
    getWorkTickets: getWorkTickets,
    getLoadingWorkTickets: getLoadingWorkTickets,
    getNumWorkTicketsPages: getNumWorkTicketPages,
    getTotalWorkTickets: getTotalWorkTickets
  };
  const pluralWorkTicketLabel = useSelector(getPluralWorkTicketLabel);
  const title = isWhitelabel() ? 'ATCOM' : 'SmartTrace';

  return (
    <div className='page' id='work-ticket-screen'>
      <Helmet>
        <title>{`${title} - ${pluralWorkTicketLabel || t('workTickets.title')}`}</title>
      </Helmet>
      <FilterBar includeGrid />
      <br />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Paper>
            <WorkTicketsList
              title={pluralWorkTicketLabel || t('workTickets.title')}
              selectors={selectors}
              fetch={fetchWorkTickets}
              showSearchBar
              showIncludeCompletedOption
              showCompletedAt
              showDeleteIcon
            />
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
}

WorkTicketScreen.propTypes = {};

WorkTicketScreen.defaultProps = {};
WorkTicketScreen.whyDidYouRender = true;
